"use client";
import React from "react";

// import { NumSlider } from "src/components/ui/NumSlider";
import Example from "../Example.jsx";
import Case from "../Case.jsx";
import Text from "../../../src/components/ui/Text";
import { NumSlider } from "src/components/ui/NumSlider";

const Var = ({ children }) => (
  <span className="font-bold">{children || ""}</span>
);

const DoublingExample = () => (
  <Example>
    <Case rate={7}>
      {({ rate, doublingPeriod, multiple, onRateChange }) => (
        <Text>
          {" "}
          With an interest rate of{" "}
          <NumSlider
            num={rate}
            percent
            step={1}
            min={1}
            max={20}
            onChange={onRateChange}
          />
          , in <Var>{Math.round(doublingPeriod)}</Var> years (which is
          approximately <Var>72/{rate}</Var>) your initial investment will
          double.
        </Text>
      )}
    </Case>
  </Example>
);

export default DoublingExample;
